export function isExecutionPatchIncrementalResult(value) {
  return !!value.incremental;
}